import { render, staticRenderFns } from "./EachCountryTabContentTopMessage.vue?vue&type=template&id=0f27ea24&scoped=true&"
import script from "./EachCountryTabContentTopMessage.vue?vue&type=script&lang=js&"
export * from "./EachCountryTabContentTopMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f27ea24",
  null
  
)

export default component.exports